var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"has",rawName:"v-has",value:(241020),expression:"241020"}],staticClass:"noActive",attrs:{"icon":"el-icon-download","loading":_vm.loading,"size":"small","data-html2canvas-ignore":""},on:{"click":_vm.handleDownload}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }